<generic-table>
    <div class="mt-8 flow-root generic-table">
        <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table class="table-auto min-w-full divide-y divide-gray-300">
                    <thead>
                        <tr>
                            <th each="{ (column, index) in state.columns }" scope="col" class="{ index == 0 ? 'pr-3 pl-4 sm:pl-0' : 'px-3' } py-3.5 text-left text-sm font-semibold text-gray-900">
                                <div if="{ CONFIG.CHECKBOX != column.type }" class="flex items-center justify-between whitespace-nowrap { column.is_sortable ? 'cursor-pointer' : '' }" onclick="{
                                            () => handleSort(column.is_sortable, column.field, column.sort_field)
                                        }">
                                    { column.label }
                                    <svg if="{ column.is_sortable }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
                                        <path if="{ column.sort_direction === 'asc' }" d="M12 4l-6 8h12l-6-8z" />
                                        <path if="{ column.sort_direction === 'desc' }" d="M12 20l-6-8h12l-6 8z" />
                                    </svg>
                                </div>
                                <my-checkbox if="{ CONFIG.CHECKBOX == column.type }" ckey="{ props.ckey }" checked="{ props.all_selected }" value="*"></my-checkbox>
                            </th>
                            <th class="relative py-3.5 pr-4 pl-3 text-right text-sm sm:pr-0"></th>
                        </tr>
                    </thead>
                    <tbody class="bg-white divide-y divide-gray-200">
                        <tr each="{ row in props.rows }" class="even:bg-gray-50" data_id="{ row.id }">
                            <td each="{ (column, index) in props.columns }" class="{ index == 0 ? 'pr-3 pl-4 sm:pl-0 font-medium text-gray-900' : ' text-gray-500 px-3' } py-4 text-sm  { column.is_wrappable ? '' : 'whitespace-nowrap' }">
                                <div if="{ CONFIG.CHECKBOX != column.type && CONFIG.EDITABLE != column.type }">
                                    <raw html="{ getCellValue(row, column) }"></raw>
                                </div>
                                <my-checkbox if="{ CONFIG.CHECKBOX == column.type }" ckey="{ props.ckey }" checked="{ getCellValue(row, column) }" value="{ row.id }"></my-checkbox>
                                <slot name="editable" row="{ row }" column="{ column }" />
                            </td>
                            <td class="relative py-4 pr-4 pl-3 text-right text-sm font-medium whitespace-nowrap sm:pr-0">
                                <slot name="actions" row="{ row }"></slot>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="mt-4">
            <pagination
                ckey="{ props.ckey }"
                total_rows="{ props.total_rows }"
                current_page="{ props.current_page }"
                page_size="{ props.page_size }"
                ></pagination>
        </div>
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS, KEYS, CONFIG } from '/src/utils/constants'
        import moment from 'moment-with-locales-es6'

        export default {
            CONFIG: CONFIG,
            onBeforeMount(props, state) {
                this.state = {
                    columns: props.columns
                };
            },

            handleSort(is_sortable, field, sortField) {
                if (is_sortable) {
                    const newDirection =
                            this.state.columns.find(c => c.field === field)?.sort_direction === 'asc'
                            ? 'desc'
                            : 'asc';

                    // Aggiorna lo stato delle colonne
                    const updatedColumns = this.state.columns.map(column => ({
                            ...column,
                            sort_direction: column.field === field ? newDirection : null
                        }));

                    this.update({columns: updatedColumns});

                    // Trigger dell'evento per il genitore
                    eventBus.trigger(EVENTS.UI.SORTING_CHANGE, {
                        ckey: this.props.ckey,
                        column: sortField || field, // Usa sort_field se presente, altrimenti field
                        direction: newDirection
                    });
                }
            },

            getCellValue(row, column) {
                let value = row[column.field]

                // Format date columns
                if (CONFIG.DATE === column.type && value) {
                    return moment.utc(value).local().format('DD/MM/YYYY')
                } else if (CONFIG.DATETIME === column.type && value) {
                    return moment.utc(value).local().format('DD/MM/YYYY HH:mm')
                }

                // 🧠 Se il valore è una stringa e contiene \r, sostituire con <br>
                if (typeof value === 'string' && value.includes('\r')) {
                    value = value.replace(/\r/g, '<br>')
                }
                if (typeof value === 'string' && value.includes('\n')) {
                    value = value.replace(/\n/g, '<br>')
                }

                // 🔗 Se la colonna è is_link, costruisco il link corretto
                if (column.is_link && value) {
                    const currentRoute = window.location.hash.split('/')[1] || ''
                    const basePath = `#/${currentRoute}`
                    const linkPrefix = column.link_prefix || basePath
                    const key_field = column.key_field || 'id'
                    value = `<a href="${linkPrefix}/${row[key_field]}" class="text-cyan-600 hover:text-cyan-800 font-bold">${value}</a>`
                }

                const result = value !== undefined ? value : ''
                return result
            }

        }
    </script>
</generic-table>
